import data from "../../../../../src/Octicon/Octicon.docs.json";
import * as React from 'react';
export default {
  data,
  React
};